import React from "react";
import { Helmet } from "react-helmet";

const page = [
  { pathName: "saglik", pageName: "Sağlık ve Hijyen" },
  function () {
    return (
      <div className="subPages_hizmetlerimiz-defaultCard IMG_4466">
        <Helmet>
          <title>Kampüs Kreş - Sağlık ve Hijyen</title>
          <meta name="title" content="Kampüs Kreş - Sağlık ve Hijyen" />
          <meta property="og:title" content="Kampüs Kreş - Sağlık ve Hijyen" />
          <meta name="twitter:title" content="Kampüs Kreş - Sağlık ve Hijyen" />
        </Helmet>
        <div className="subPages_hizmetlerimiz-defaultCard_firstColumn">
          <p>
            <strong>Okul öncesi</strong> dönem, çocukların hızlı büyüme ve{" "}
            <strong>gelişim</strong> gösterdiği, aynı zamanda bağışıklık
            sistemlerinin güçlendiği kritik bir dönemdir. Bu süreçte sık
            karşılaşılan bazı hastalıklar, çocukların bağışıklıklarının doğal
            yollarla gelişmesine katkı sağlar. Bu nedenle, çocukların sosyal
            ortamlardan tamamen uzak tutulması yerine, sağlık sürecinin
            kontrollü şekilde takip edileceği güvenli bir <strong>kreş</strong>{" "}
            ortamında bulunmaları büyük önem taşır.
          </p>
          <div
            className="img"
            style={{
              background: `url(${require("../../../../assets/IMG_4466.jpg")})`,
            }}
          />
        </div>
        <div className="subPages_hizmetlerimiz-defaultCard_secondColumn">
          <p>
            <strong>Kampüs Kreş</strong> olarak, öğrencilerimizi ve siz değerli
            velilerimizi bu süreçte destekleyen yapılandırılmış bir sağlık
            sistemimiz mevcuttur. Kayıt döneminde sizlere sunulan “Revir Formu”
            ile başlayan bu süreç, öğrencimizin sağlık durumuna özel olarak
            takip edilmekte ve kayıt altına alınmaktadır.
            <br />
            <br />
            <strong>Anaokulu</strong> ve <strong>çocuk gelişimi</strong>{" "}
            perspektifiyle oluşturulan bu sistem,
            <strong>Kampüs Kreş</strong> bünyesinde okul hemşiremiz tarafından
            yürütülmektedir. Bu sistemde; hastalık durumları, hangi
            hastalıklarda öğrencinin raporlu olarak gelmesi gerektiği, ilaç
            etiketlerinin doğru kullanımı, bulaşıcı hastalıklarda izlenen
            protokoller, acil durum planlamaları, ilaç uygulama yöntemleri ve
            hijyen-dezenfeksiyon süreçleri detaylı olarak yönetilmektedir.
            Özellikle ateşli durumlarda veliyle kurulan hızlı iletişim ve
            bilgilendirme süreci, sistemimizin önemli bir parçasını
            oluşturmaktadır.
            <br />
            <br />
            Sağlık konusunda oldukça hassas davranıyor, çocukların sağlıklı bir
            ortamda <strong>okul öncesi eğitim</strong> sürecini güvenle
            sürdürebilmeleri ve <strong>çocuk gelişimi</strong> açısından risk
            yaşamamaları adına gerekli tüm önlemleri alıyoruz. Revir öğrenci
            dosyası ise sizlerle aramızdaki en güçlü iletişim araçlarından
            biridir.
            <br />
            <br />
            Küçük yaşta sağlık bilinci kazanmanın öneminin farkında olan bir
            yaklaşımla, <strong>Kampüs Kreş</strong> sağlık sistemimizi düzenli
            olarak gözden geçiriyor, hijyen kontrollerini sık aralıklarla
            gerçekleştiriyoruz. Böylece hem öğrencilerimizin sağlığını koruyor
            hem de onların
            <strong>gelişimini</strong> güvenli bir şekilde destekliyoruz.
            <br />
            <br />
          </p>
        </div>
      </div>
    );
  },
];

export default page;
